import React, { useMemo, useState } from "react";
import styled from "styled-components";
import { Mail, Search, ShieldCheck, UserRound } from "lucide-react";

const Page = styled.main`
  color: #172033;
`;

const Header = styled.section`
  margin-bottom: 18px;
  padding: 24px 26px;
  border: 1px solid #e4edf8;
  border-radius: 8px;
  background: linear-gradient(135deg, #ffffff 0%, #eef6ff 100%);

  h1 {
    margin: 0 0 8px;
    font-size: 30px;
  }

  p {
    margin: 0;
    color: #66758f;
  }
`;

const Toolbar = styled.section`
  display: grid;
  grid-template-columns: 1fr 150px;
  gap: 10px;
  margin-bottom: 16px;
  padding: 14px;
  border: 1px solid #e4edf8;
  border-radius: 8px;
  background: #fff;
`;

const SearchBox = styled.label`
  display: flex;
  align-items: center;
  gap: 9px;
  height: 42px;
  padding: 0 13px;
  border: 1px solid #dce6f2;
  border-radius: 7px;
  color: #8da0b8;

  input {
    width: 100%;
    border: 0;
    outline: 0;
  }
`;

const Select = styled.select`
  height: 42px;
  border: 1px solid #dce6f2;
  border-radius: 7px;
  background: #fff;
  color: #35445c;
  padding: 0 12px;
  font-weight: 800;
`;

const Grid = styled.section`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 14px;
`;

const Card = styled.article`
  padding: 18px;
  border: 1px solid #e3ebf7;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 12px 28px rgba(32, 72, 122, 0.06);
`;

const Top = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;
`;

const Avatar = styled.div`
  display: grid;
  place-items: center;
  width: 46px;
  height: 46px;
  border-radius: 50%;
  background: #eaf3ff;
  color: #2f80ed;
`;

const Name = styled.div`
  strong {
    display: block;
    font-size: 16px;
  }

  span {
    color: #66758f;
    font-size: 12px;
  }
`;

const Info = styled.div`
  display: grid;
  gap: 9px;
  color: #66758f;
  font-size: 13px;

  div {
    display: flex;
    align-items: center;
    gap: 7px;
  }
`;

const Badge = styled.span`
  display: inline-flex;
  margin-top: 14px;
  border-radius: 999px;
  padding: 7px 10px;
  background: ${(props) => (props.$vip ? "#eef6ff" : "#f3f4f6")};
  color: ${(props) => (props.$vip ? "#2f70cf" : "#66758f")};
  font-size: 12px;
  font-weight: 900;
`;

const members = [
  { id: 1, name: "김민준", email: "minjun@example.com", grade: "VIP", orders: 18, spent: 8420000, joined: "2025.11.02" },
  { id: 2, name: "이서연", email: "seoyeon@example.com", grade: "Silver", orders: 6, spent: 1290000, joined: "2026.01.14" },
  { id: 3, name: "박지훈", email: "jihun@example.com", grade: "Gold", orders: 11, spent: 3350000, joined: "2025.09.20" },
  { id: 4, name: "최유진", email: "yujin@example.com", grade: "Silver", orders: 3, spent: 890000, joined: "2026.03.05" },
];

export default function AdminMembers() {
  const [keyword, setKeyword] = useState("");
  const [grade, setGrade] = useState("전체");

  const filteredMembers = useMemo(() => {
    return members.filter((member) => {
      const target = `${member.name} ${member.email}`.toLowerCase();
      return (!keyword || target.includes(keyword.toLowerCase())) && (grade === "전체" || member.grade === grade);
    });
  }, [grade, keyword]);

  return (
    <Page>
      <Header>
        <h1>회원 관리</h1>
        <p>구매 등급, 주문 이력, 연락 정보를 기반으로 고객을 관리합니다.</p>
      </Header>

      <Toolbar>
        <SearchBox><Search size={17} /><input value={keyword} onChange={(event) => setKeyword(event.target.value)} placeholder="이름 또는 이메일 검색" /></SearchBox>
        <Select value={grade} onChange={(event) => setGrade(event.target.value)}>
          <option>전체</option><option>Silver</option><option>Gold</option><option>VIP</option>
        </Select>
      </Toolbar>

      <Grid>
        {filteredMembers.map((member) => (
          <Card key={member.id}>
            <Top>
              <Avatar><UserRound size={22} /></Avatar>
              <Name><strong>{member.name}</strong><span>{member.joined} 가입</span></Name>
            </Top>
            <Info>
              <div><Mail size={15} /> {member.email}</div>
              <div><ShieldCheck size={15} /> 주문 {member.orders}건 · ₩ {member.spent.toLocaleString("ko-KR")}</div>
            </Info>
            <Badge $vip={member.grade === "VIP"}>{member.grade} 등급</Badge>
          </Card>
        ))}
      </Grid>
    </Page>
  );
}
